'use strict';

var _ = require('lodash');
var UserManagementRoleManagementTransformerFactory = function UserManagementRoleManagementTransformerFactory(DataTransformer) {
  var ROLES_HIDDEN_ON_UI = 'INTERFACE';
  function UserManagementRoleManagementTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'user-management-role-management-mode';
  }
  UserManagementRoleManagementTransformer.prototype = Object.create(DataTransformer.prototype);
  UserManagementRoleManagementTransformer.constructor = UserManagementRoleManagementTransformer;
  UserManagementRoleManagementTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  UserManagementRoleManagementTransformer.prototype.isCacheable = function () {
    return false;
  };
  UserManagementRoleManagementTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  UserManagementRoleManagementTransformer.prototype.transform = function (data) {
    return _.transform(data.domain.roles, function (result, value) {
      if (!value.roles[0].includes(ROLES_HIDDEN_ON_UI)) {
        var item = {
          role: value.roles[0],
          usersAssigned: value.usersAssigned
        };
        result.push(item);
      }
    }, []);
  };
  return UserManagementRoleManagementTransformer;
};
UserManagementRoleManagementTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = UserManagementRoleManagementTransformerFactory;